import React from 'react';
import { Box, Typography } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import OurLink from './OurLink';
import SingleViewPageTabs from './ViewPageTabs';
import ActionButton from '../../ui/primitives/ActionButton';
import { useAccess } from '../../hooks/useAccess';

const SecondaryHeader = ({
  activeTab,
  setActiveTab,
  pageTitle,
  breadcrumbs,
  tabHeaders,
  otherDetails,
  backTo,
  showBackButton,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { projectId } = useParams();
  const { canAccess } = useAccess();

  const mainPageUrl = `/project/${projectId}${
    location.pathname.includes('/testcycles') || location.pathname.includes('/testplayer')
      ? '/testcycles'
      : '/testcases'
  }`;

  const handleTabSelect = (tab) => {
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('type', tab);
    navigate(`${location.pathname}${currentUrl.search}`, { state: location.state });
    setActiveTab(tab);
  };

  const handleBack = () => {
  if (backTo) {
    navigate(backTo, { state: location.state });
  } else if (window.history.length > 1) {
    navigate(-1);
  } else {
    navigate(mainPageUrl);
  }
};

  const filteredTabs = tabHeaders?.filter((tab) =>
    tab?.policy ? canAccess(tab.policy) : true
  );

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 1.5,
        }}
      >
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
            {breadcrumbs?.map((crumb, index) => (
              <React.Fragment key={index}>
                <OurLink
                  to={crumb.path}
                  className={
                    index === breadcrumbs.length - 1 && !crumb.clickable
                      ? 'text-secondary'
                      : ''
                  }
                  clickable={crumb.clickable}
                >
                  {crumb.label}
                </OurLink>
                {index < breadcrumbs.length - 1 && (
                  <Typography variant="caption" color="text.disabled">
                    {'>'}
                  </Typography>
                )}
              </React.Fragment>
            ))}
          </Box>

          <Typography
            variant="h5"
            fontWeight={600}
            sx={{ overflowWrap: 'anywhere', lineHeight: 1.3 }}
          >
            {pageTitle}
          </Typography>

          {otherDetails && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {otherDetails}
            </Typography>
          )}
        </Box>

        {showBackButton && (
          <ActionButton
            label="Back"
            icon={<KeyboardBackspaceIcon />}
            intent="ghost"
            size="small"
            onClick={handleBack}
            tooltip="Go back"
          />
        )}
      </Box>

      <Box>
        <SingleViewPageTabs
          activeTab={activeTab}
          onTabSelect={handleTabSelect}
          tabHeaders={filteredTabs}
        />
      </Box>
    </Box>
  );
};

export default SecondaryHeader;
